import { render } from "./MngCheckResult.vue?vue&type=template&id=23957667&ts=true"
import script from "./MngCheckResult.vue?vue&type=script&lang=ts"
export * from "./MngCheckResult.vue?vue&type=script&lang=ts"

import "./MngCheckResult.vue?vue&type=style&index=0&id=23957667&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__